webpackJsonp([217034719394758],{

/***/ 1211:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BillingGroupFeeType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Flat dollar amount fee","isDeprecated":false,"name":"FLAT"},{"deprecationReason":null,"description":"Whichever is greater: flat amount or percentage","isDeprecated":false,"name":"GREATER_THAN"},{"deprecationReason":null,"description":"Percentage-based fee","isDeprecated":false,"name":"PERCENT"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-billing-group-fee-type-6a5f816655603038eb18.js